__turbopack_context__.v({
  "medicalDirectory": "medical-directory-module__rbfn8q__medicalDirectory",
});
